const eventDialogStyle = {
    wrapper: {
        // width: '55%',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        // border: 'solid 0.5px white',
        borderRadius: '1.5%',
        // boxShadow: '-2px 4px 10px 0px rgba(0,0,0,0.75)',
    },
    item: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    createItem: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    rightInput: {
        width: '74%',
    },
    rightCreate: {
        width: '74%',
    },
    right: {
        margin: '0 0 15px 0',
    },
    rightDisable: {
        margin: '0 0 15px 0',
        pointerEvents: 'none',
    },

    leftTitle: {
        width: '25%',
        textAlign: 'left',
        paddingRight: '46px',
    },
    leftTitleItem: {
        width: '25%',
        paddingLeft: '20px',
    },
    CustomButton: {
        marginRight: '60px',
    },
    button: {
        marginLeft: '55%',
    },
    customButtonUpload: {
        display: 'flex',
        alignItems: 'center',
        color: 'black',
        lineHeight: 1.43,
        transition:
        'box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        marginRight: 'auto',
    },
    inputFile: {
        position: 'fixed',
        left: '100%',
    },
    checkBox: {
        '& span': {
            fontSize: '14px',
        },
    },
    radioButton: {
        '& span': {
            fontSize: '14px',
        },
    },

    numberInput: {
        width: '200px',
    },

    input: {
        '& input': {
            padding: '6px',
            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    time: {
        marginBottom: '15px',
    },
    name: {
        '& input': {
            padding: '6px',
            width: '333px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    numberInputPriceLiveStream: {
        width: '70px',
    },
    price: {
        '&:after': {
            content: '"円"',
            transform: 'translateX(calc(100% + 10px))',
        },
    },
};
export default eventDialogStyle;
